/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Submitted_AtInputs */

const en_admin_registration_submitted_at = /** @type {(inputs: Admin_Registration_Submitted_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted on`)
};

const de_admin_registration_submitted_at = /** @type {(inputs: Admin_Registration_Submitted_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingegangen am`)
};

/**
* | output |
* | --- |
* | "Submitted on" |
*
* @param {Admin_Registration_Submitted_AtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_submitted_at = /** @type {((inputs?: Admin_Registration_Submitted_AtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Submitted_AtInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_submitted_at(inputs)
	return en_admin_registration_submitted_at(inputs)
});